import { TableData } from "../tableContext/TableContext";
import { TableSectionData, TableSectionView } from "./sectionTable.interface";

export const getTableSectionsItems = (
  sections: TableSectionData[],
): TableData[] =>
  sections.flatMap((section) => [
    ...(section.data ?? []),
    ...getTableSectionsItems(section.sections ?? []),
  ]);

export const getTableSectionsView = (
  sections: TableSectionData[],
  rowLimit = Infinity,
): TableSectionView[] => {
  let remainingRows = rowLimit;

  const getViews = (items: TableSectionData[]): TableSectionView[] => {
    const views: TableSectionView[] = [];

    for (const section of items) {
      if (remainingRows <= 0) break;
      const sectionData = section.data ?? [];
      const data =
        sectionData.length <= remainingRows
          ? sectionData
          : sectionData.slice(0, remainingRows);
      remainingRows -= data.length;
      const children = getViews(section.sections ?? []);

      views.push({
        section,
        data,
        sections: children,
        rowCount: children.reduce(
          (count, child) => count + child.rowCount,
          data.length,
        ),
      });
    }

    return views;
  };

  return getViews(sections);
};
